<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> MOTIVO CANCELAMENTO ROYALTIES</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-toolbar-title v-if="reason_cancellation.id"
          >{{ reason_cancellation.id }} -
          {{ reason_cancellation.description.toUpperCase() }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn outlined color="grey darken-3" @click="goToBackList()">
          <v-icon left>mdi-chevron-left</v-icon> Voltar
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <alert
            :visible="!!error"
            dark
            type="error"
            :message="error"
            :clickClose="() => (error = '')"
          />
          <v-row>
            <v-col cols="12" xs="12" md="6">
              <v-text-field
                v-model="reason_cancellation.description"
                class="text-field-uppercase"
                label="Descrição"
                dense
                outlined
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" md="6"> </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn color="blue darken-3" dark class="mt-5" @click="validate">
                <v-icon left>mdi-send</v-icon> Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>

<script>
import { URL } from "@/api/config";
import Alert from "@/components/Alert";

export default {
  components: {
    Alert,
  },
  data: () => ({
    loading: false,
    error: "",
    reason_cancellation: {
      id: "",
      description: "",
    },
    valid: true,
    lazy: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
  }),
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id) {
        this.getReasonCancellation(this.$route.params.id);
      }
    },
    async getReasonCancellation(id) {
      this.loading = true;
      try {
        let response = await fetch(`${URL}reason-cancellation-royalties/${id}`);
        this.reason_cancellation = await response.json();
        console.log(this.reason_cancellation);
      } catch (error) {
        this.reason_cancellation = {};
        console.log(error);
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    goToBackList() {
      this.$router.push({ name: "ReasonCancellationRoyalties" });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.reason_cancellation.description =
          this.reason_cancellation.description.toUpperCase();
        let data = new URLSearchParams(this.reason_cancellation);
        if (this.reason_cancellation.id === "") {
          this.post(data);
        } else {
          this.update(this.reason_cancellation.id, data);
        }
      }
    },
    async post(data) {
      this.loading = true;
      try {
        let res = await fetch(`${URL}reason-cancellation-royalties`, {
          method: "POST",
          body: data,
        });
        if (res) {
          this.goToBackList();
        }
      } catch (error) {
        console.log(error);
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    async update(id, data) {
      this.loading = true;
      try {
        let res = await fetch(`${URL}reason-cancellation-royalties/${id}`, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
          method: "PUT",
          body: data,
        });
        if (res) {
          this.goToBackList();
        }
      } catch (error) {
        this.error = error.message;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style>
.text-field-uppercase input {
  text-transform: uppercase;
}
</style>
